import http from '../utils/http';

// 用户
const user = {
    /**
     * 权限-用户-列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @param {Object} options
     * @param {Number} options.departmentId 部门id
     * @param {String} options.mobile 手机号码
     * @param {Number} options.pageNum 分页-页码
     * @param {Number} options.pageSize 分页-每页条数
     * @param {String} options.realName 真实姓名
     * @param {String} options.roleName 角色名称
     * @param {Number} options.status 启用、禁用（1：启用；0：禁用）
     * @param {String} options.userName 用户名称
     * @returns Promise
     */
    userList(options) {
        return http.post('/user/list', options)
    },
    /**
     * @parameter   权限-用户-新增
     * @parameter   departmentId(number):部门ID
     * @parameter   mobilePhone（string）：手机号
     * @parameter   realName（string）：姓名
     * @parameter   userName（string）：账号
     * @parameter   status（number）：状态
     * @parameter   roleId（number）：角色Id
    */
    save(options){
        return http.post("/user/save",options)
    },
    /**
     * @parameter 权限-用户-修改
     * @parameter   departmentId(number):部门id
     * @parameter   mobilePhone（string）：手机号码
     * @parameter   roleIds（number）：角色id
     * @parameter   status（number）：状态
     * @parameter   userId（number）：用户Id
     * @parameter   userName（string）：用户名
    */
    update(options){
        return http.post("/user/update",options)
    },
    /**
     * @parameter   重置密码
     * @parameter   userId（number）：用户ID
     * @parameter   password（string）：密码
    */
    resetPassword(options){
        return http.post("/user/resetPassword",options)
    },
    /**
     * @parameter   修改用户状态
     * @parameter   userId（number）：用户ID
     * @parameter   status（number）：状态
    */
    enableDisableUser(options){
        return http.post("/user/enableDisableUser",options)
    },

    /**
     * @parameter   删除
     * @parameter   userId（number）：用户ID
     */
    delete(options){
        return http.post("/user/delete",options)
    },

    /**
     * 用户-播控助手-树形结构
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#203
     * @returns Promise
     */
    playControlTree(){
        return http.post('/devicegroup/tree');
    },

    // 请求终端分组
    getDeviceGroups(userId){
        return http.post("/devicegroup/usertree",{
           userId
        })
    },

    // 设置用户终端组权限
    saveGroups(options){
        return http.post("/user/saveUserDeviceGroup",options)
    }
}

export default user;
